import { useContext } from "react";
import { FormPropertyContext } from "./context";

export const usePropertyContext = () => {
    const context = useContext(FormPropertyContext);

    if (context) {
        return context;
    }

    throw new Error(`usePropertyContext must be used within the context`);
};
